<template>
  <div class="section-container">
    <div class="image-container">
      <template v-if="!additionalImages || additionalImages.length === 0">
        <video
          v-if="isVideoUrl(imageUrl)"
          :src="imageUrl"
          class="carouselImg"
          disablePictureInPicture
          playsinline
          preload="metadata"
          autoplay
          muted
          loop
        />
        <img
          v-else
          :src="imageUrl"
          :style="{ cursor: 'pointer' }"
          @click="() => showMedia(imageUrl)"
        />
      </template>
      <div v-else>
        <Carousel :items-to-show="1" :wrap-around="true" ref="myCarousel">
          <Slide v-for="media in carouselImages" :key="media" @click="() => showMedia(media)">
            <div class="carousel__item">
              <video
                v-if="isVideoUrl(media)"
                :src="media"
                class="carouselImg"
                disablePictureInPicture
                playsinline
                preload="metadata"
                autoplay
                muted
                loop
              />
              <img v-else :src="media" alt="" class="carouselImg" />
            </div>
          </Slide>

          <template #addons>
            <Navigation />
            <Pagination />
          </template>
        </Carousel>
      </div>
    </div>
    <div class="text-container">
      <div class="title">
        {{ title }}
      </div>
      <span class="subtitle" v-if="date">{{ formattedDate }} </span>
      <div v-html="description"></div>
      <table></table>
    </div>
  </div>
  <vue-easy-lightbox
    v-if="lightboxVisible"
    :visible="lightboxVisible"
    :imgs="lightboxImages"
    :index="lightboxIndex"
    @hide="onHideLightbox"
    moveDisabled
    rotateDisabled
    zoomDisabled
    @contextmenu.prevent="disableRightClick"
    pinchDisabled
  ></vue-easy-lightbox>
</template>

<script setup>
import { disableRightClick } from '@/includes/helper'
import { computed, defineProps, onMounted, ref } from 'vue'
import { Carousel, Navigation, Pagination, Slide } from 'vue3-carousel'

const lightboxVisible = ref(false)
const lightboxIndex = ref(0)

const props = defineProps({
  title: String,
  description: String,
  date: String,
  imageUrl: String,
  additionalImages: Array
})

const carouselImages = ref([])
const myCarousel = ref(null)

// vue-easy-lightbox only knows how to display images, so videos/gifs (gifs
// render fine through it, same as an <img>) shouldn't be included as videos -
// exclude actual video files from the lightbox media list
const isVideoUrl = url => /\.(mp4|webm|mov|ogg|m4v)(\?.*)?$/i.test(url || '')
const lightboxImages = computed(() => carouselImages.value.filter(media => !isVideoUrl(media)))

const showMedia = media => {
  // Videos have their own native controls - open the lightbox only for images/gifs
  if (isVideoUrl(media)) return

  const index = lightboxImages.value.indexOf(media)
  lightboxIndex.value = index >= 0 ? index : 0

  lightboxVisible.value = true
}
const onHideLightbox = () => (lightboxVisible.value = false)

carouselImages.value =
  props.additionalImages && props.additionalImages?.length > 0
    ? [props.imageUrl, ...props.additionalImages]
    : [props.imageUrl]

const formattedDate = ref('')

onMounted(() => {
  //format the date
  const options = { month: 'long', day: 'numeric', year: 'numeric' }
  formattedDate.value = new Date(props.date).toLocaleDateString(undefined, options)
})
</script>

<style scoped>
.carousel__pagination {
  padding-top: 0;
}

.image-container video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.image-container video::-webkit-media-controls-overflow-button,
.image-container video::-internal-media-controls-overflow-button {
  display: none !important;
}
</style>
